export class CenaMontazu {
    id: string;
    /**
     * kW
     */
    moc_od = 0;
    /**
     * kW
     */
    moc_do = 0; // todo sprawdzic
    /**
     * identyfikator dostawcy
     */
    dostawca_id = '';
    /**
     * Cena montażu instalacji o mocy w przedziale okreslonej moc_od moc_do
     */
    cena = 0;

    confirmed = false;
    isFilledCorrectly(): boolean {
        return this.cena > 0 && this.moc_do > 0 && this.moc_od > 0 && this.moc_od < this.moc_do;
    }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/cena.ts